import React from 'react';
import './content.css'

export default function Footer(){
    return(
        <div className="footer"> 
            <div className ="container">
                <p>Septembre 2020 &copy; #GeniusOfDigital - #GOD</p>
            </div>
        </div>
    )
}

